shvenergy.footer = (function ($) {
    "use strict";

    function init() {

        var allHeaders = $("button.page-footer__link-list-header");
        var allLinkLists = $(".page-footer__link-list");
        var followUsList = $(".page-footer .follow-us__list a");

        allHeaders.each(function () {

            var header = $(this);
            var otherHeaders = allHeaders.not(header);

            header.on("click", function (e) {
                e.preventDefault();

                if (shvenergy.utils.isMobile()) {

                    if (header.hasClass("selected")) {
                        header.removeClass("selected").attr("aria-expanded", "false");
                        allLinkLists.slideUp();
                    } else {
                        header.addClass("selected").attr("aria-expanded", "true");
                        otherHeaders.removeClass("selected").attr("aria-expanded", "false");
                        allLinkLists.slideUp();
                        $(this).next(".page-footer__link-list").slideDown();
                    }
                }

            });
        });
        followUsList.each(function () {
            let anchor = $(this),
                title = anchor.find('.visuallyhidden').text();
            anchor.on("click", function() {
                trackFooterSocialClick(title);
            });

            anchor.on("auxclick", function() {
                trackFooterSocialClick(title);
            });
        });

        function trackFooterSocialClick(title) {
            shvenergy.tracking.trackRawEventData({
                event: 'clickFooterSocial',
                socialName: title
            });
        }
	}

	init();

})(jQuery);